<template>
<div>
  <div class="row">
    <div class="col-md-12 intro">
      <h4>Atualize seus doadores e seguidores</h4>
      <span>Mantenha seus doadores e aqueles que admiram sua Organização Social com publicações regulares.
        Aqui você pode mantê-los atualizados em relação às novidades de sua iniciativa</span>
    </div>
  </div>
  <div class="row" v-if="showMsg || showMsgSuccess">
    <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
      {{msg}}
      <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div v-if="showMsgSuccess" class="alert alert-success alert-dismissible fade show" role="alert">
      {{msgSuccess}}
      <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

  <div class="row">
   
    <div class="col-md-4">
      <h4>Título</h4>
      <span>Qual título quer para seu post?</span>
    </div>
    <div class="col-md-8">
      <div class="form-group">
        <input type="text" v-model="title" class="form-control"/>
        <span>Até 40 caracteres.</span>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-4">
      <h4>Texto</h4>
      <span>Fale sobre eventos, melhorias, novos membros. Deixe o seu projeto vivo.</span>
    </div>
    <div class="col-md-8">
      <div class="form-group">
        <vue-editor v-model="text"></vue-editor>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-4">
      <b-form-checkbox id="checkbox1" value="true"
          unchecked-value="false" v-model="sendToFollowers">
        Enviar para seguidores e doadores
      </b-form-checkbox>
    </div>
    <div class="col-md-8">
      <button class="btn" v-on:click.stop.prevent="publishUpdate()">Publicar atualização</button>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <h3>Lista de Atividades</h3>
      <div v-if="activities">
        <div class="activity" v-for="a in activities" v-bind:key="a.ProjectActivityId">
          <h5>{{a.title}}</h5>
          <div v-html="a.text"></div>
          <span>{{getTimeDifference(a.timestamp)}}</span>
          <button class="btn" v-on:click.stop.prevent="removeUpdate(a.ProjectActivityId)">Remover</button>
        </div>
      </div>
      <h4 class="projects-empty" v-if="!activities || activities.length == 0">Você não possui atividades.</h4>
    </div>
  </div>
</div>
</template>

<script>
import auth from '../../services/auth'
import Functions from '../../utils/functions'
import { API } from '../../services/api'
import { VueEditor } from 'vue2-editor'

export default {
  name: 'ProjectActivities',
  props: ['project'],
  components: {
    VueEditor
  },
  data(){
    return {
      msg: '',
      showMsg: false,
      msgSuccess: '',
      showMsgSuccess: false,
      projectId: null,
      title: null,
      text: null,
      activities: null,
      sendToFollowers: false,
      page: 'activities'
    }
  },
  mounted(){
    this.projectId = this.project.ProjectId;
    if(this.project.Activities){
      this.activities = this.project.Activities;
    }
  },
  methods: {
    publishUpdate(){
      this.showMsg = false;
      this.showMsgSuccess = false;
      this.$emit('showloading');
      if(this.validate()){
        this.$http.post(API.Projects.updateProject + this.projectId, {title: this.title, text: this.text, page: this.page, action: 'insert', sendToFollowers: this.sendToFollowers}, 
        {headers: auth.getHeaders()}).then((res) => {
            if(res.body.success === true){
              this.msgSuccess = res.body.message;
              this.showMsgSuccess = true;
              this.title = null;
              this.text = null;
              this.sendToFollowers = false;
              if(!this.activities){
                this.activities = [];
              }
              this.activities.push(res.body.activity);
            }else{
              this.msg = res.body.message;
              this.showMsg = true;
            }
            this.$emit('hideloading');
          }, (err) => {
            this.$emit('hideloading');
            this.msg = err.body.message;
            this.showMsg = true;
          });
      }else{
        this.$emit('hideloading');
      }
    },
    removeUpdate(ProjectActivityId){
      var r = confirm("Deseja remover esta atualização?");
      if(r == true){
        this.$emit('showloading');
        this.$http.post(API.Projects.updateProject + this.projectId, {ProjectActivityId: ProjectActivityId, page: this.page, action: 'delete'}, 
        {headers: auth.getHeaders()}).then((res) => {
            if(res.body.success === true){
              this.successMsg = res.body.message;
              this.showSuccessMsg = true;
              this.activities = this.activities.filter((a) => {
                return a.ProjectActivityId !== ProjectActivityId
              })
            }else{
              this.msg = res.body.message;
              this.showMsg = true;
            }
            this.$emit('hideloading');
          });
      }
    },
    validate(){
      if(!this.title || this.title == ''){
        this.msg = 'Deve inserir um título para a atualização.';
        this.showMsg = true;
        return false;
      }
      if(!this.text || this.text == ''){
        this.msg = 'Deve inserir um conteúdo para a atualização.';
        this.showMsg = true;
        return false;
      }
      return true;
    },
    hideMsg(){
      this.msg = "";
      this.msgSuccess = "";
      this.showMsg = false;
      this.showMsgSuccess = false;
    },
    getTimeDifference(timestamp){
      return Functions.timeDifference(timestamp)
    }
  }
}
</script>

<style lang="scss" scoped>
.alert-success, .alert-danger{
  width: 100%;
}
h4{
  color: #00AE39;
  margin-bottom: 1px;
}
span{
  font-size: 15px;
}
.projects-empty{
  width: 100%;
  padding: 20px;
  text-align: center;
  margin-top: 20px;
}
.form-config{
    margin-top: 20px;
    .row{
      padding: 20px;
      border-bottom: thin solid #eee;
      &:last-child{
        border-bottom: none;
      }
    }
    .btn{
      font-size: 22px;
      color: #fff;
      background-color: #00AE39;
      &.clear-project{
        background-color: red;
      }
      &:hover{
        background-color: #aaa;
        color: #333;
      }
    }
}

.activity{
  padding: 10px;
  background-color: #eee;
  margin-top: 20px;
  border-radius: 5px;
  font-size: 14px;
  display: block;
  position: relative;
  h5{
    font-family: RalewayBold;
    padding-bottom: 10px;
  }
  .btn{
    font-size: 14px;
    background-color: red;
    position: absolute;
    right: 10px;
    top: 10px;
  }
  span{
    font-size: 12px;
    color: #999;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/manage-project/Activities.vue